import React from 'react';
import styled from 'styled-components'
import { SkeletonLine } from './skeleton'

const DealStats = (props) => {


    /*
      const stats = {
        conversionRate,
        biggestWin,
        biggestLoss,
        averageDealSizeWon,
      };
    
    */

    // format currency $ no decimal places, no currency country code
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });

    const formatDollars = (dollars) => {
        return formatter.format(dollars);
    }

    const truncate = (text, max) => {
        if (!text) return '';
        return text.length > max ? text.slice(0, max) + '...' : text;
    }


    const loading = props.loading || !props.data;

    return (
        <Container>
            <Card>
                {loading ? (
                    <>
                        <SkeletonLine $w="120px" $h="14px" />
                        <SkeletonLine $w="80px" $h="24px" style={{ marginTop: 6 }} />
                    </>
                ) : (
                    <>
                        <Title>Average $ Sale</Title>
                        <Figure>{formatDollars(props.data.averageDealSizeWon)}</Figure>
                    </>
                )}
            </Card>
            <Card>
                {loading ? (
                    <>
                        <SkeletonLine $w="130px" $h="14px" />
                        <SkeletonLine $w="70px" $h="24px" style={{ marginTop: 6 }} />
                    </>
                ) : (
                    <>
                        <Title>Conversion Rate</Title>
                        <Figure>{Math.round(props.data.conversionRate)}%</Figure>
                    </>
                )}
            </Card>
            <Card>
                {loading ? (
                    <>
                        <SkeletonLine $w="150px" $h="14px" />
                        <SkeletonLine $w="60px" $h="24px" style={{ marginTop: 6 }} />
                    </>
                ) : (
                    <>
                        <Title>Avg Days to Close</Title>
                        <Figure>{props.data.averageDaysToClose}</Figure>
                    </>
                )}
            </Card>
            <Card>
                {loading ? (
                    <>
                        <SkeletonLine $w="110px" $h="14px" />
                        <SkeletonLine $w="100px" $h="24px" style={{ marginTop: 6 }} />
                        <SkeletonLine $w="160px" $h="12px" style={{ marginTop: 8 }} />
                    </>
                ) : (
                    <>
                        <Title>Biggest Win</Title>
                        {props.data.biggestWin !== 0 ? (
                            <>
                                <Figure>{formatDollars(props.data.biggestWin.properties.amount)}</Figure>
                                <Note title={props.data.biggestWin.properties.dealname}>{truncate(props.data.biggestWin.properties.dealname, 36)}</Note>
                            </>
                        ) : (
                            <Figure>No data available</Figure>
                        )}
                    </>
                )}
            </Card>
        </Container>
    );
}

export default DealStats;
const Container = styled.div`
    display: flex;
    flex-wrap: nowrap; /* This ensures that the divs stay in one line */
    justify-content: space-between; /* Optional: Add space between divs */
    column-gap: 20px;
    margin-bottom: 30px;
    margin-top: 40px;

    @media (max-width: 768px) {
        flex-wrap: wrap; 
    }

`;


const Title = styled.h2`
    font-size: 0.85rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8A94A6;
    margin: 0;
`;

const Figure = styled.p`
    font-size: 1.8rem;
    color: #0b1220;
    margin: 6px 0 0 0;
`;

const Note = styled.p`
    font-size: .8rem;
    color:  #6a7380;
    margin: 6px 0 0 0;
`;


const Card = styled.div` 
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 18px 20px;
    border-radius: 12px;
    background: rgba(255,255,255,0.78);
    border: 1px solid #e9edf3;
    box-shadow: 0 6px 18px rgba(0,0,0,0.12);
    backdrop-filter: blur(6px);
    min-height: 90px;

    @media (max-width: 768px) {
        flex-basis: calc(50% - 20px);
        margin-bottom: 12px;
    }
`;

